import type { JSX } from 'react';
import parse from 'html-react-parser';

import i18n from '@/i18n';
import { urlRegex } from '@/utils';

const linkParser = (text = ''): string | JSX.Element | JSX.Element[] =>
  parse(
    text.replace(
      urlRegex,
      `<a href='$1' style="color: #2357DE;">${i18n.t('utils.linkParser.link')}</a>`
    )
  );

export default linkParser;
